import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Edit, Trash2, Package as PackageIcon } from "lucide-react";
import { toast } from "sonner";

export default function AdminPackages() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const refresh = () => api.get("/admin/packages").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const save = async () => {
    if (!edit) return;
    try {
      const payload = { ...edit, features: edit.features };
      if (edit.id) await api.put(`/admin/packages/${edit.id}`, payload);
      else await api.post("/admin/packages", payload);
      toast.success("Pacchetto salvato");
      setEdit(null); refresh();
    } catch (e) { toast.error("Errore"); }
  };
  const del = async (id) => { if (!window.confirm("Eliminare?")) return; try { await api.delete(`/admin/packages/${id}`); refresh(); } catch (e) { toast.error("Errore"); } };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-display text-2xl font-bold text-slate-900">Pacchetti</h1><p className="text-sm text-slate-600">Gestisci i pacchetti commerciali.</p></div>
        <Button onClick={() => setEdit({ name: "", description: "", duration: "", features: [], monthly_price: 0, one_time_price: 0, active: true })} className="bg-[#2D6BFF] text-white"><Plus size={14} className="mr-1" /> Nuovo</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(p => (
          <div key={p.id} className="cxo-card p-5">
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-slate-900 flex items-center gap-2"><PackageIcon size={16} className="text-[#2D6BFF]" />{p.name}</h3>
              <div className="flex gap-1"><Button size="sm" variant="ghost" onClick={() => setEdit(p)}><Edit size={14} /></Button><Button size="sm" variant="ghost" onClick={() => del(p.id)}><Trash2 size={14} className="text-red-500" /></Button></div>
            </div>
            <p className="text-sm text-slate-600 mt-2">{p.description}</p>
            <p className="text-xs text-slate-500 mt-2">Durata: {p.duration}</p>
            <div className="mt-3 flex gap-4 text-sm cxo-tabular">{p.monthly_price && <span>€{p.monthly_price}/mese</span>}{p.one_time_price && <span>€{p.one_time_price} una tantum</span>}</div>
          </div>
        ))}
      </div>
      {edit && (
        <Dialog open onOpenChange={(o) => !o && setEdit(null)}>
          <DialogContent>
            <DialogHeader><DialogTitle>{edit.id ? "Modifica" : "Nuovo"} pacchetto</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nome</Label><Input value={edit.name} onChange={e => setEdit({...edit, name: e.target.value})} /></div>
              <div><Label>Descrizione</Label><Textarea rows={3} value={edit.description || ""} onChange={e => setEdit({...edit, description: e.target.value})} /></div>
              <div><Label>Durata</Label><Input value={edit.duration || ""} onChange={e => setEdit({...edit, duration: e.target.value})} /></div>
              <div><Label>Features (virgola)</Label><Input value={(edit.features || []).join(", ")} onChange={e => setEdit({...edit, features: e.target.value.split(",").map(s => s.trim()).filter(Boolean)})} /></div>
              <div className="grid grid-cols-2 gap-2"><div><Label>Prezzo mensile</Label><Input type="number" value={edit.monthly_price || ""} onChange={e => setEdit({...edit, monthly_price: parseFloat(e.target.value) || 0})} /></div><div><Label>Prezzo una tantum</Label><Input type="number" value={edit.one_time_price || ""} onChange={e => setEdit({...edit, one_time_price: parseFloat(e.target.value) || 0})} /></div></div>
            </div>
            <DialogFooter><Button onClick={save} className="bg-[#2D6BFF] text-white">Salva</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
